// Standard YAML's Core schema.
// http://www.yaml.org/spec/1.2/spec.html#id2804923
//
// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
// So, Core schema has no distinctions from JSON schema is JS-YAML.


'use strict';


var Schema = require('../schema');


module.exports = new Schema({
  include: [
    require('./json')
  ]
});



/*****************
 ** WEBPACK FOOTER
 ** ../~/js-yaml/lib/js-yaml/schema/core.js
 ** module id = 407
 ** module chunks = 0
 **/